import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const StyledHeader = styled("div")(({ theme }) => ({
  height: theme.spacing(5),
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  background: theme.palette.primary.light,
  color: "white",
  fontWeight: "bold",
  paddingTop: theme.spacing(0.5)
}));

export const StyledContainer = styled("div")(({ theme }) => ({
  border: `1px solid grey`,
  // minWidth: theme.spacing(72)
  position: "fixed",
  top: 128,
  bottom: 65,
  left: 100,
  right: 100
}));

export const StyledHeaderText = styled("span")(({ theme }) => ({
  marginLeft: theme.spacing(1),
  fontSize: theme.spacing(3.25)
}));

export const ReviewButton = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.warning.main,
  color: theme.palette.common.white,
  height: theme.spacing(4),
  borderRadius: 0,
  marginRight: 15,

  "&:hover": {
    backgroundColor: theme.palette.warning.dark,
  },

  "&:disabled": {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.contrastText,
    borderColor: theme.palette.warning.light,
    opacity: 0.6,
    cursor: "not-allowed"
  }
}));

export default { StyledContainer, StyledHeader };
